export default "__VITE_ASSET__ki4W4H4o__"